import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Container,
  Jumbotron,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { getSetting } from '../../helpers/Settings';
import { isValidUrl } from '../../helpers/Validators';

const PageSectionCollectionFullWidth = ({ section, isLoggedIn }) => {
  const { collection } = section;
  const intl = useIntl();
  if (!collection) {
    return null;
  }

  const customStyle = {
    ...(getSetting('cs1') && { borderLeftColor: '#dc1f2b' }),
  };

  const LinkTag = (!isLoggedIn && isValidUrl(collection.custom_url)) ? 'a' : Link;

  return (
    <>
      {collection && (
        <Jumbotron
          style={{
            backgroundImage: collection.featured_file ? `url('${collection.featured_file.urls.featured}')` : '',
          }}
          className="custom-page-section featured-jumbotron"
          fluid
        >
          <Container>
            <div className="jumbotron-content" style={customStyle}>
              <h1>{collection.title}</h1>
              <p>
                <LinkTag
                  to={LinkTag === 'a' ? undefined : `/collections/${collection.uuid}`}
                  href={LinkTag === 'a' ? collection.custom_url : undefined}
                >
                  {collection.subtitle ? (
                    collection.subtitle
                  ) : (
                    intl.formatMessage({ defaultMessage: 'View Photos' })
                  )}
                </LinkTag>
              </p>
            </div>
          </Container>
        </Jumbotron>
      )}
    </>
  );
};

PageSectionCollectionFullWidth.propTypes = {
  section: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

export default PageSectionCollectionFullWidth;
